import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Title, Breadcrumbs, WrapperFlex } from '@unimed-fesp/components';
import { Creators as ParametroActions } from '../../store/ducks/parametro';
import history from '../../services/history';

import FadeIn from '../../components/atoms/FadeIn';
import TableParametros from '../../components/organisms/TableParametros';
import theme from '../../styles/theme';

import { Container } from './styles';

const Parametros = () => {
  const dispatch = useDispatch();
  const parametros = useSelector((state) => state.parametro.data);

  useEffect(() => {
    dispatch(ParametroActions.getParametrosRequest());

    return () => {
      dispatch(ParametroActions.renew());
    };
  }, [dispatch]);

  return (
    <Container>
      <FadeIn>
        <Title
          text="parâmetros"
          color={theme.titleGray}
          fontSize={38}
          marginBottom={8}
        />
        <Breadcrumbs
          crumbs={[
            { path: 'novo' },
            {
              path: 'parametros',
              onNavigate: () => history.push('/novo/parametros'),
            },
          ]}
        />
        <WrapperFlex marginTop={25} justifyStart alignStart row>
          <TableParametros parametros={parametros} />
        </WrapperFlex>
      </FadeIn>
    </Container>
  );
};

export default Parametros;
